import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { ThemeSwitch } from '@/components/theme-switch'
import { AuthButton } from '@/features/auth/index'
import { Editor as EditorEntry } from '@/features/editor'
import { ConfirmDialog } from '@/features/editor/components/confirm-dialog'
import { useEditorBootstrap } from '@/features/editor/hooks/use-editor-bootstrap'
import { useUnsavedChangesGuard } from '@/features/editor/hooks/use-unsaved-changes-guard'
import { TransactionsDialog } from '@/features/transactions'

const searchSchema = z.object({
  engineId: z.string().optional(),
  vType: z.enum(['draft', 'reviewing', 'published']).optional(),
})

export const Route = createFileRoute('/_authenticated/editor/')({
  validateSearch: (search) => searchSchema.parse(search),
  component: Editor,
})

export function Editor() {
  const { engineId, vType } = Route.useSearch()

  const q = useEditorBootstrap(engineId ?? null, vType)

  // 统一拦截：路由离开 + beforeunload
  const guard = useUnsavedChangesGuard()

  if (q.isLoading) return <div>Loading...</div>
  if (q.isError) return <div>Load failed</div>

  return (
    <>
      <Header>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <TransactionsDialog />
          <AuthButton />
        </div>
      </Header>

      <EditorEntry />

      <ConfirmDialog
        open={guard.confirmOpen}
        title='有未保存的更改'
        description='你对当前草稿做了修改但还没保存。离开后这些更改将丢失，是否继续？'
        destructive
        confirmText='离开'
        cancelText='继续编辑'
        onCancel={guard.stay}
        onConfirm={guard.leave}
      />
    </>
  )
}
